export var ConnectorType;
(function (ConnectorType) {
    ConnectorType["CONNECTOR_TYPE_AWS_ACCOUNT_CONNECTOR"] = "AWS_ACCOUNT_CONNECTOR";
    ConnectorType["CONNECTOR_TYPE_GCP_PROJECT_CONNECTOR"] = "GCP_PROJECT_CONNECTOR";
})(ConnectorType || (ConnectorType = {}));
